// Reconstructed from production code; original paths and local names were not available.
import React from "react";
import * as jsxRuntime from "react/jsx-runtime";
const AuthContext = React.createContext(null);
function AuthProvider({ children: children }) {
  const [user, setUser] = React.useState(null),
    [authReady, setAuthReady] = React.useState(false);
  React.useEffect(() => {
    try {
      const y = localStorage.getItem("user");
      y && setUser(JSON.parse(y));
    } catch (y) {
      console.error("Failed to read user from storage", y);
    } finally {
      setAuthReady(true);
    }
  }, []);
  const login = (y, g) => {
      setUser(y);
      localStorage.setItem("user", JSON.stringify(y));
      localStorage.setItem("token", g);
    },
    logout = () => {
      setUser(null);
      localStorage.removeItem("user");
      localStorage.removeItem("token");
    };
  return (
    <AuthContext.Provider
      value={{
        user: user,
        login: login,
        logout: logout,
        authReady: authReady,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
function useAuth() {
  return React.useContext(AuthContext);
}
export { AuthContext, AuthProvider, useAuth };
